import React, { useState, useEffect } from "react";
import { Dropdown, Alert, Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";

import TaskFilters from "./TaskFilters";
import TaskStatsCards from "./TaskStatsCards";

import { getTaskData } from "../../../APIS";

const Tasks = () => {
  const [reportData, setReportData] = useState({ data: [] });
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [formData, setFormData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const itemsPerPage = 15;
  const storedUser = sessionStorage.getItem("userDetails");
  const [filterAssignee, setFilterAssignee] = useState("All");
  const [filterAssignedBy, setFilterAssignedBy] = useState("All");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  let token = null;
  if (storedUser) {
    const userDetails = JSON.parse(storedUser);
    token = userDetails?.token;
  }

  const fetchReports = async () => {
    setLoading(true);
    try {
      const data = await getTaskData(token);
      setReportData(data);
      setFilteredData(data.data);
    } catch (err) {
      setError("Failed to fetch tasks.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, []);

  useEffect(() => {
    let filtered = reportData.data;

    if (filterAssignee !== "All") {
      filtered = filtered.filter((t) => t.assigned_to?.name === filterAssignee);
    }
    if (filterAssignedBy !== "All") {
      filtered = filtered.filter(
        (t) => t.created_by?.name === filterAssignedBy
      );
    }
    if (dateFrom) {
      filtered = filtered.filter(
        (t) => new Date(t.createdAt) >= new Date(dateFrom)
      );
    }
    if (dateTo) {
      filtered = filtered.filter(
        (t) => new Date(t.createdAt) <= new Date(dateTo)
      );
    }

    filtered = filtered.filter((t) =>
      [t.name, t.status, t.assigned_to?.name].some((field) =>
        field?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );

    setFilteredData(filtered);
    setCurrentPage(0);
  }, [
    searchTerm,
    filterAssignee,
    filterAssignedBy,
    dateFrom,
    dateTo,
    reportData,
  ]);

  const handleView = (data) => {
    setFormData(data);
  };

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const currentItems = filteredData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );
  // ✅ ADD THIS HERE
  const counts = {
    total: reportData.data.length,
    completed: reportData.data.filter((t) => t.status === "completed").length,
    ongoing: reportData.data.filter((t) => t.status === "ongoing").length,
    pending: reportData.data.filter((t) => t.status === "pending").length,
  };
  return (
    <div className="col-12">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center flex-wrap">
          {/* <h4 className="card-title mb-2 mb-md-0">Tasks</h4> */}
          <div className="col-12">
            <TaskStatsCards
              counts={counts}
              onFilter={(status) => {
                if (status === "All") setFilteredData(reportData.data);
                else
                  setFilteredData(
                    reportData.data.filter((t) => t.status === status)
                  );
              }}
            />
          </div>

          <TaskFilters
            dateFrom={dateFrom}
            dateTo={dateTo}
            setDateFrom={setDateFrom}
            setDateTo={setDateTo}
            assigneeList={[
              ...new Set(
                reportData.data.map((t) => t.assigned_to?.name).filter(Boolean)
              ),
            ]}
            assignedByList={[
              ...new Set(
                reportData.data.map((t) => t.created_by?.name).filter(Boolean)
              ),
            ]}
            filterAssignee={filterAssignee}
            setFilterAssignee={setFilterAssignee}
            filterAssignedBy={filterAssignedBy}
            setFilterAssignedBy={setFilterAssignedBy}
            resetFilters={() => {
              setFilterAssignee("All");
              setFilterAssignedBy("All");
              setDateFrom("");
              setDateTo("");
            }}
          />

          {/* {!formData && (
            <Form
              className="d-flex"
              style={{ maxWidth: "300px", width: "100%" }}
            >
              <Form.Control
                type="text"
                value={searchTerm}
                placeholder="Search by Title,Date,Status or Assignee"
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Form>
          )} */}
        </div>

        <div className="card-body">
          {successMsg && (
            <Alert
              variant="success"
              dismissible
              onClose={() => setSuccessMsg(null)}
            >
              {successMsg}
            </Alert>
          )}
          {error && (
            <Alert variant="danger" dismissible onClose={() => setError(null)}>
              {error}
            </Alert>
          )}
          {loading && <p>Loading tasks...</p>}

          {!loading && !error && (
            <>
              {formData ? (
                <form>
                  <div className="row">
                    <div className="col-xl-6">
                      <div className="mb-3 row">
                        <label className="col-lg-4 col-form-label">Title</label>
                        <div className="col-lg-4">
                          <input
                            type="text"
                            value={formData.name || ""}
                            className="form-control"
                            disabled
                          />
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="col-lg-4 col-form-label">
                          Status
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="text"
                            value={formData.status || ""}
                            className="form-control"
                            disabled
                          />
                        </div>
                      </div>
                      {formData.assigned_to && (
                        <>
                          <div className="mb-3 row">
                            <label className="col-lg-4 col-form-label">
                              Assignee Name
                            </label>
                            <div className="col-lg-6">
                              <input
                                type="text"
                                value={formData.assigned_to.name || ""}
                                className="form-control"
                                disabled
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="col-lg-4 col-form-label">
                              Assignee Role
                            </label>
                            <div className="col-lg-6">
                              <input
                                type="text"
                                value={formData.assigned_to.role || ""}
                                className="form-control"
                                disabled
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="col-xl-6">
                      <div className="mb-3 row">
                        <label className="col-lg-4 col-form-label">
                          Description
                        </label>
                        <div className="col-lg-6">
                          <textarea
                            value={formData.description || ""}
                            className="form-control"
                            rows={3}
                            disabled
                          />
                        </div>
                      </div>

                      {formData.assigned_to && (
                        <div className="mb-3 row">
                          <label className="col-lg-4 col-form-label">
                            Assignee Email
                          </label>
                          <div className="col-lg-6">
                            <input
                              type="text"
                              value={formData.assigned_to.email || ""}
                              className="form-control"
                              disabled
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="mb-3 row">
                      <div className="col-lg-10 ms-auto">
                        <button
                          onClick={() => setFormData(null)}
                          className="btn btn-secondary"
                        >
                          Back to List
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              ) : (
                <>
                  <div className="table-responsive">
                    <table
                      className="table table-striped"
                      id="Reports_basic_table"
                    >
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Title</th>
                          <th>Date</th>
                          <th>Status</th>
                          <th>Assigned To</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.map((r, i) => (
                          <tr key={i}>
                            <td>{r._id?.slice(-5) || "--"}</td>
                            <td>{r.name || "--"}</td>
                            <td>
                              {r.createdAt
                                ? new Date(r.createdAt)
                                    .toISOString()
                                    .split("T")[0]
                                : "--"}
                            </td>
                            <td>
                              <span
                                className={`badge light ${
                                  r.status === "completed"
                                    ? "badge-success"
                                    : r.status === "ongoing"
                                    ? "badge-warning"
                                    : "badge-danger"
                                }`}
                              >
                                <i
                                  className={`fa fa-circle me-1 ${
                                    r.status === "completed"
                                      ? "text-success"
                                      : r.status === "ongoing"
                                      ? "text-warning"
                                      : "text-danger"
                                  }`}
                                />
                                {r.status
                                  ? r.status.charAt(0).toUpperCase() +
                                    r.status.slice(1)
                                  : "--"}
                              </span>
                            </td>
                            <td>{r.assigned_to?.name || "--"}</td>
                            <td>
                              <Dropdown>
                                <Dropdown.Toggle variant="link">
                                  •••
                                </Dropdown.Toggle>
                                <Dropdown.Menu align="end">
                                  <Dropdown.Item onClick={() => handleView(r)}>
                                    View Task
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div>
                      Showing {currentPage * itemsPerPage + 1} to{" "}
                      {Math.min(
                        (currentPage + 1) * itemsPerPage,
                        filteredData.length
                      )}{" "}
                      of {filteredData.length} entries
                    </div>
                    <div>
                      <button
                        className={`btn btn-sm btn-outline-primary me-2 ${
                          currentPage === 0 ? "disabled" : ""
                        }`}
                        onClick={() =>
                          currentPage > 0 && setCurrentPage(currentPage - 1)
                        }
                      >
                        Prev
                      </button>
                      {Array.from({ length: totalPages }, (_, i) => (
                        <button
                          key={i}
                          className={`btn btn-sm border me-2 ${
                            currentPage === i ? "btn-primary text-white" : ""
                          }`}
                          onClick={() => setCurrentPage(i)}
                        >
                          {i + 1}
                        </button>
                      ))}
                      <button
                        className={`btn btn-sm btn-outline-primary ${
                          currentPage === totalPages - 1 ? "disabled" : ""
                        }`}
                        onClick={() =>
                          currentPage + 1 < totalPages &&
                          setCurrentPage(currentPage + 1)
                        }
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Tasks;
